import { Box, MenuItem, Select } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledSelect = styled(Select)``;

export const StyledItem = styled(MenuItem)`
  /* font-size: ${(p) => p.theme.typography.caption.fontSize};
    color: ${(p) => p.theme.palette.primary[500]};
    border-bottom: 1px solid ${(p) => p.theme.palette.grey[200]};
  &.Mui-selected {
    background-color: ${(p) => p.theme.palette.common.white}; */
`;
